import constate from 'constate';
import { useMemo } from 'react';
import { MakhazinAuthApi } from '../Api/MakhazinAuthApi';
import { useUserContext } from './UserContext';
const useAPIContext = () => {
    const userContext = useUserContext();
    const api = useMemo(() => {
        if (userContext.accessToken && userContext.refreshToken) {
            return new MakhazinAuthApi(userContext.accessToken, userContext.refreshToken, userContext.handleRefreshedToken, userContext.logoutUser, userContext.impersonatedAs);
        }
        else {
            return undefined;
        }
    }, [
        userContext.accessToken,
        userContext.refreshToken,
        userContext.handleRefreshedToken,
        userContext.impersonatedAs,
        userContext.logoutUser,
    ]);
    return { api };
};
export const [Provider, useApi] = constate(useAPIContext, value => value.api);
